export function localDateTime(date = new Date()) {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
}

export function toCentimeters(value, unit) {
  const text = String(value).trim();
  if (!/^\d+(?:\.\d+)?$/.test(text)) throw new Error('請輸入有效的腰圍數字（小數點請使用 .）。');
  const cm = Number(text) * (unit === 'in' ? 2.54 : 1);
  if (!Number.isFinite(cm) || cm < 0.01 || cm > 999.99) throw new Error('腰圍須介於 0.01 與 999.99 公分。');
  return Math.round((cm + Number.EPSILON) * 100) / 100;
}

export function displayWaist(cm, unit = 'cm') {
  return (Number(cm) / (unit === 'in' ? 2.54 : 1)).toFixed(1);
}

export function errorMessage(error) {
  if (error.response?.status === 403) return '沒有操作此紀錄的權限，請確認管理關聯。';
  if (error.response?.status === 401) return '登入已失效，請重新登入。';
  const data = error.response?.data;
  if (data?.errors) return Object.values(data.errors).flat().join(' ');
  if (typeof data === 'string') return data;
  return error.response ? '操作失敗，請稍後再試。' : error.message || '連線失敗，請稍後再試。';
}
